import { AutoComplete, Col, Divider, Form, Input, Radio, Row } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { useUser } from 'contexts/User';
import RecommendedEdit from 'pages/Setting/RecommendedList/RecommendedEdit';
import Button from 'components/Button';
import { AddFillIcon } from 'assets/svg';
import { CloseSquareFilled } from '@ant-design/icons';
import { useMutation } from 'react-query';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import handleError401 from 'utils/handleError401';
import CreateBrandDetail from '../Brand/CreateBrandDetail';
import { IPostEmailQuery } from 'interface/brand.interface';

interface Iparam {
  id?: string;
}

export default function Step2(): JSX.Element {
  const history = useHistory();
  const allocateData = useLocation().state as any;
  const { id } = useParams<Iparam>();
  const { user } = useUser();
  const dateFormat = 'YYYY';
  const setStep = useCategoryManagementStore((state) => state.setStep);
  const [declareDetail, setDeclareDeatail] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [brandEmail, setBrandEmail] = useState<any>([]);
  const [listbrandEmail, setListBrandEmail] = useState<any>([]);
  const [brandData, setBrandData] = useState<any>();
  const [actionList, setActionList] = useState<any>([]);
  const [branchLV1, setBranchLV1] = useState<any>([]);
  const [branchLV2, setBranchLV2] = useState<any>([]);
  const [headquartersLV1, setHeadquartersLV1] = useState<any>([]);
  const [headquartersLv2, setHeadquartersLV2] = useState<any>([]);

  useEffect(() => {
    setStep(1);
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent('');
  };

  const onNextStep = () => {
    // if (products.length != 0) {
    closeModal();
    history.push(`/recommended-list/edit/step2`);
    // } else {
    //   openModal('Chưa có sản phẩm nào được đồng bộ, vui lòng đồng bộ sản phẩm');
    // }
  };

  const handlecreateAllocation = async () => {
    // createAllocation(declareDetail);
    // history.push(`/recommended-list/edit/step2`);
  };

  const { mutate: getUser } = useMutation(RoleBasedAuth.getUsers, {
    onSuccess: (response) => {
      setOptions(getPanelValue(response?.data));
    },
    onError: () => {
      handleError401();
    },
  });

  const mockVal = (listData: any) => {
    return {
      label:
        listData.fullName +
        ' - ' +
        listData.jobTitle +
        ' - ' +
        listData.departmentName,
      value: listData.id + ' - ' + listData.email,
    };
  };

  const getPanelValue = (data: any) => {
    const dataOptions = [];
    for (let i = 0; i < data.length; i++) {
      dataOptions.push(mockVal(data[i]));
    }
    return dataOptions;
  };

  const [options, setOptions] = useState<{ value: any; label: string }[]>([]);
  const [selectedValue, setSelectedValue] =
    useState<{ value: any; label: string }>();
  const onSelect = (value: string) => {
    const str_email = value.split(' - ');
    const dataEmail = {} as unknown as IPostEmailQuery;
    dataEmail.pro_grp_id = brandData?.id;
    dataEmail.pro_grp_level = 3;
    dataEmail.user_id = Number(str_email[0]);
    dataEmail.email = str_email[1];
    setBrandEmail([dataEmail]);
    console.log(value);
  };

  function handleOnchangeValueFilter(event: any, action: any) {
    if (event != '' && event != undefined && String(event).indexOf('@') >= 0)
      getUser({ email: event });
    else setSelectedValue(undefined);
  }

  const handleAddEmailManage = () => {
    const newEmail = [...brandEmail];
    setListBrandEmail(newEmail);
  };

  const onSelectPush = (value: string) => {
    const str_email = value.split(' - ');
    const dataEmail = {} as unknown as IPostEmailQuery;
    dataEmail.pro_grp_id = brandData?.id;
    dataEmail.pro_grp_level = 3;
    dataEmail.user_id = Number(str_email[0]);
    dataEmail.email = str_email[1];
    brandEmail.push(dataEmail);
  };

  const handleDeleteEmailManage = (index: number) => {
    const newEmail = [...brandEmail];
    newEmail.splice(index, 1);
    setListBrandEmail(newEmail);
    if (newEmail.length > 0) setBrandEmail(newEmail);
  };

  return (
    <RecommendedEdit>
      <Form
        layout="vertical"
        className="items-center"
        onFinish={onNextStep}
        autoComplete="off"
      >
        <Content>
          <Row justify="space-between" align="middle">
            <Col span={24}>
              <div className="text-xl font-bold">2. Thiết lập phê duyệt</div>
            </Col>
          </Row>

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="mt-4"
            style={{ marginLeft: '5px' }}
          >
            <Row className="mb-1">
              <Col span={24} className="text-sm font-bold mb-3">
                1.Phát hành danh mục
              </Col>
              <Col span={24}>
                <Radio.Group>
                  <Radio value={1}>Duyệt tuần tự</Radio>
                  <Radio value={2}>Duyệt đồng cấp</Radio>
                </Radio.Group>
              </Col>
            </Row>
          </Row>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="mt-4"
            style={{ marginLeft: '5px' }}
          >
            <Col className="" span={12}>
              <Form.Item label="Email người phê duyệt">
                <Input.Group compact>
                  <AutoComplete
                    options={options}
                    style={{
                      width: 'calc(100% - 105px)',
                      marginRight: '8px',
                    }}
                    value={selectedValue?.label}
                    onSelect={(value, label) => {
                      onSelect(label.value);
                      setSelectedValue(label);
                    }}
                    onChange={(event) =>
                      handleOnchangeValueFilter(event, 'email')
                    }
                    allowClear={{ clearIcon: <CloseSquareFilled /> }}
                  />
                  <Button
                    bgColor={'white'}
                    border={'neutral-90'}
                    customClass={'no-show'}
                    onClick={handleAddEmailManage}
                  >
                    <AddFillIcon />
                  </Button>
                </Input.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col className="" span={12} style={{ marginTop: '-10px' }}>
              {listbrandEmail?.map((item: any, index: number) => (
                <CreateBrandDetail
                  key={index}
                  item={item}
                  index={index}
                  onSelectPush={onSelectPush}
                  handleDeleteEmailManage={handleDeleteEmailManage}
                  handleAddEmailManage={handleAddEmailManage}
                />
              ))}
            </Col>
          </Row>
          <Col>
            <Divider
              style={{
                borderTop: '1px dashed rgba(0, 0, 0, 0.2)',
                marginTop: '8px',
                marginBottom: '8px',
              }}
              dashed
            />
          </Col>
          <Col span={24} className="text-sm font-bold mb-3 mt-3">
            2.Đăng ký giỏ hàng danh mục
          </Col>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="mt-4"
            style={{ marginLeft: '5px' }}
          >
            <Row className="mb-1">
              <Col span={24} className="text-sm font-bold mb-3">
                A. Chi nhánh (Chỉ phê duyệt đơn thuộc chi nhánh)
              </Col>
              <Col
                span={24}
                className="text-sm font-bold ml-3 mb-3"
                style={{ color: '#00538F' }}
              >
                Phê duyệt cấp 1
              </Col>
              <Col span={24}>
                <Radio.Group>
                  <Radio value={1}>Duyệt tuần tự</Radio>
                  <Radio value={2}>Duyệt đồng cấp</Radio>
                </Radio.Group>
              </Col>
              <Col span={24}>
                <Col className="ml-3 mt-2" span={12}>
                  <Form.Item label="Email người quản lý">
                    <Input.Group compact>
                      <AutoComplete
                        options={options}
                        style={{
                          width: 'calc(100% - 105px)',
                          marginRight: '8px',
                        }}
                        value={selectedValue?.label}
                        onSelect={(value, label) => {
                          onSelect(label.value);
                          setSelectedValue(label);
                        }}
                        onChange={(event) =>
                          handleOnchangeValueFilter(event, 'email')
                        }
                        allowClear={{ clearIcon: <CloseSquareFilled /> }}
                      />
                      <Button
                        bgColor={'white'}
                        border={'neutral-90'}
                        customClass={'no-show'}
                        onClick={handleAddEmailManage}
                      >
                        <AddFillIcon />
                      </Button>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col className="" span={12} style={{ marginTop: '-10px' }}>
                  {listbrandEmail?.map((item: any, index: number) => (
                    <CreateBrandDetail
                      key={index}
                      item={item}
                      index={index}
                      onSelectPush={onSelectPush}
                      handleDeleteEmailManage={handleDeleteEmailManage}
                      handleAddEmailManage={handleAddEmailManage}
                    />
                  ))}
                </Col>
              </Col>

              <Col
                span={24}
                className="text-sm font-bold ml-3 mb-2"
                style={{ color: '#00538F' }}
              >
                Phê duyệt cấp 2
              </Col>
              <Col span={24}>
                <Radio.Group>
                  <Radio value={1}>Duyệt tuần tự</Radio>
                  <Radio value={2}>Duyệt đồng cấp</Radio>
                </Radio.Group>
              </Col>
              <Col span={24}>
                <Col className="ml-3 mt-2" span={12}>
                  <Form.Item label="Email người quản lý">
                    <Input.Group compact>
                      <AutoComplete
                        options={options}
                        style={{
                          width: 'calc(100% - 105px)',
                          marginRight: '8px',
                        }}
                        value={selectedValue?.label}
                        onSelect={(value, label) => {
                          onSelect(label.value);
                          setSelectedValue(label);
                        }}
                        onChange={(event) =>
                          handleOnchangeValueFilter(event, 'email')
                        }
                        allowClear={{ clearIcon: <CloseSquareFilled /> }}
                      />
                      <Button
                        bgColor={'white'}
                        border={'neutral-90'}
                        customClass={'no-show'}
                        onClick={handleAddEmailManage}
                      >
                        <AddFillIcon />
                      </Button>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col className="" span={12} style={{ marginTop: '-10px' }}>
                  {listbrandEmail?.map((item: any, index: number) => (
                    <CreateBrandDetail
                      key={index}
                      item={item}
                      index={index}
                      onSelectPush={onSelectPush}
                      handleDeleteEmailManage={handleDeleteEmailManage}
                      handleAddEmailManage={handleAddEmailManage}
                    />
                  ))}
                </Col>
              </Col>
            </Row>
          </Row>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="mt-4"
            style={{ marginLeft: '5px' }}
          >
            <Row className="mb-1">
              <Col span={24} className="text-sm font-bold mb-3">
                B. Hội sở
              </Col>
              <Col
                span={24}
                className="text-sm font-bold ml-3 mb-3"
                style={{ color: '#00538F' }}
              >
                Phê duyệt cấp 1
              </Col>
              <Col span={24}>
                <Radio.Group>
                  <Radio value={1}>Duyệt tuần tự</Radio>
                  <Radio value={2}>Duyệt đồng cấp</Radio>
                </Radio.Group>
              </Col>
              <Col span={24}>
                <Col className="ml-3 mt-2" span={12}>
                  <Form.Item label="Email người quản lý">
                    <Input.Group compact>
                      <AutoComplete
                        options={options}
                        style={{
                          width: 'calc(100% - 105px)',
                          marginRight: '8px',
                        }}
                        value={selectedValue?.label}
                        onSelect={(value, label) => {
                          onSelect(label.value);
                          setSelectedValue(label);
                        }}
                        onChange={(event) =>
                          handleOnchangeValueFilter(event, 'email')
                        }
                        allowClear={{ clearIcon: <CloseSquareFilled /> }}
                      />
                      <Button
                        bgColor={'white'}
                        border={'neutral-90'}
                        customClass={'no-show'}
                        onClick={handleAddEmailManage}
                      >
                        <AddFillIcon />
                      </Button>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col className="" span={12} style={{ marginTop: '-10px' }}>
                  {listbrandEmail?.map((item: any, index: number) => (
                    <CreateBrandDetail
                      key={index}
                      item={item}
                      index={index}
                      onSelectPush={onSelectPush}
                      handleDeleteEmailManage={handleDeleteEmailManage}
                      handleAddEmailManage={handleAddEmailManage}
                    />
                  ))}
                </Col>
              </Col>

              <Col
                span={24}
                className="text-sm font-bold ml-3 mb-2"
                style={{ color: '#00538F' }}
              >
                Phê duyệt cấp 2
              </Col>
              <Col span={24}>
                <Radio.Group>
                  <Radio value={1}>Duyệt tuần tự</Radio>
                  <Radio value={2}>Duyệt đồng cấp</Radio>
                </Radio.Group>
              </Col>
              <Col span={24}>
                <Col className="ml-3 mt-2" span={12}>
                  <Form.Item label="Email người quản lý">
                    <Input.Group compact>
                      <AutoComplete
                        options={options}
                        style={{
                          width: 'calc(100% - 105px)',
                          marginRight: '8px',
                        }}
                        value={selectedValue?.label}
                        onSelect={(value, label) => {
                          onSelect(label.value);
                          setSelectedValue(label);
                        }}
                        onChange={(event) =>
                          handleOnchangeValueFilter(event, 'email')
                        }
                        allowClear={{ clearIcon: <CloseSquareFilled /> }}
                      />
                      <Button
                        bgColor={'white'}
                        border={'neutral-90'}
                        customClass={'no-show'}
                        onClick={handleAddEmailManage}
                      >
                        <AddFillIcon />
                      </Button>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col className="" span={12} style={{ marginTop: '-10px' }}>
                  {listbrandEmail?.map((item: any, index: number) => (
                    <CreateBrandDetail
                      key={index}
                      item={item}
                      index={index}
                      onSelectPush={onSelectPush}
                      handleDeleteEmailManage={handleDeleteEmailManage}
                      handleAddEmailManage={handleAddEmailManage}
                    />
                  ))}
                </Col>
              </Col>
            </Row>
          </Row>
        </Content>
        <Divider
          style={{
            borderTop: '1px solid rgba(0, 0, 0, 0.2)',
            marginTop: '8px',
            marginBottom: '8px',
          }}
        />
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
          <Col
            className="flex justify-end"
            span={8}
            style={{ marginTop: '20px', marginRight: '2px' }}
          >
            <Button onClick={() => history.push(`/recommended-list`)}>
              Trở lại
            </Button>
            <Button
              // type="submit"
              //   disabled={
              //     declareDetail?.capital_name != undefined &&
              //     declareDetail?.capital_value != undefined &&
              //     declareDetail?.capital_year != undefined
              //       ? false
              //       : true
              //   }
              //   bgColor={
              //     declareDetail?.capital_name != undefined &&
              //     declareDetail?.capital_value != undefined &&
              //     declareDetail?.capital_year != undefined
              //       ? 'bg-primary-50'
              //       : 'bg-gray-300'
              //   }
              onClick={handlecreateAllocation}
            >
              Tạo danh mục
            </Button>
          </Col>
        </Row>
      </Form>
    </RecommendedEdit>
  );
}
